// extracted by mini-css-extract-plugin
export default {"title":"nama-lengkap-pembeli-properti_title__VQGVM"};